import axios from "axios";
import apiConfig from "./config";
import Vue from "vue";
let { baseUrl } = apiConfig;
import router from "@/router";
// if (process.env.NODE_ENV == 'development') {
// 	axios.defaults.baseURL = baseUrl;
// } else if (process.env.NODE_ENV == 'production') {
// 	axios.defaults.baseURL = baseUrlPro;
// }
// 请求超时时间
axios.defaults.timeout = 3600 * 1000;

axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

let loadingCount = 0;
// 在某个方法中调用
import { Loading } from "element-ui";
// 开启加载
let loadingInstance = null;

const showLoading = (params, options) => {
  if (params.noloading == undefined || !params.noloading) {
    if (loadingCount === 0) {
      loadingInstance = Loading.service({
        lock: true,
        text: "加载中...",
        customClass: "m-loading-page",
        background: "rgba(0, 0, 0, 0.3)",
        ...options,
      });
    }
    loadingCount++;
  }
};
const closeLoading = (params) => {
  if (params.noloading == undefined || !params.noloading) {
    if (loadingCount <= 0) return;
    loadingCount--;
    if (loadingCount === 0 && loadingInstance) {
      loadingInstance.close();
      loadingInstance = null;
    }
  }
};

let timer = null;

export function get(url, params, config, headers) {
  // 开发环境用代理，生产环境也用相对路径通过 Nginx 代理
  url = baseUrl + url;
  timer = null;
  showLoading(config);
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: headers,
        params: params,
      })
      .then((res) => {
        closeLoading(config);
        if (res.status == 200) {
          if (res.data.Success) {
            resolve(res.data);
          } else {
            reject(res.data);
          }
        } else {
          reject(res.data);
        }
      })
      .catch((err) => {
        if (err.response.data && err.response.data.Success) {
          closeLoading(config);
          resolve(err.response.data);
        } else {
          closeLoading(config);
          if (err.response.data && err.response.data.Message) {
            Vue.prototype.$message({
              message: err.response.data.Message,
              type: "error",
            });
          }
          reject(err.response.data);
        }
      });
  });
}
export function post(url, params, config, headers) {
  // 开发环境用代理，生产环境也用相对路径通过 Nginx 代理
  url = baseUrl + url;
  timer = null;
  showLoading(config);
  return new Promise((resolve, reject) => {
    if (config.is_array) {
      params = params.list;
    }
    axios
      .post(url, params, {
        headers: headers,
      })
      .then((res) => {
        closeLoading(config);
        if (res.status == 200) {
          if (res.data.Success || res.data.Coordinates.length > 0) {
            resolve(res.data);
          } else {
            reject(res.data);
          }
        } else {
          reject(res.data);
        }
      })
      .catch((err) => {
        if (err.response.data && err.response.data.Success) {
          closeLoading(config);
          resolve(err.response.data);
        } else {
          closeLoading(config);
          reject(err.response.data);
        }
      });
  });
}
